import React from 'react';

import { QualificationProvider } from './src/contexts/qualificationContext';

export const onClientEntry = async () => {
  if (typeof IntersectionObserver === 'undefined') {
    await require('intersection-observer');
  }
};

export function wrapPageElement({ element, props }) {
  const Layout = element.type.Layout ?? React.Fragment;
  return (
    <QualificationProvider>
      <Layout {...props}>{element}</Layout>
    </QualificationProvider>
  );
}
